import { render, staticRenderFns } from "./ImportInvoicePaymentsModal.vue?vue&type=template&id=0c35cfa6"
import script from "./ImportInvoicePaymentsModal.vue?vue&type=script&lang=js"
export * from "./ImportInvoicePaymentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports